<template>
  <v-main>
    <div class="datePicker">
      <v-btn icon class="v-calendar-left-button ma-2" @click="changeMonth(0)">
        <img src="@/assets/btn_back.png" alt="required" width="20" />

      </v-btn>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on }">
          <v-btn  v-on="on" icon class="ma-2" @click="resetPicker()">
            <span class="monthYear" style="-webkit-text-stroke: 0.5px black; color: black; font-size: 24px; font-family: 'Open Sans'; font-weight: bold;">{{monthYear}}</span>
          </v-btn>
        </template>
        <v-date-picker
          ref="datePicker"
          :locale="vuetifyLocale"
          @click:year="yearSelected = true"
          v-model="picker"
          @input="menu = false"
          type="month"
          :events="this.arrayEvents ? [...this.arrayEvents.approved] : []"
          :event-color="eventColorFunction"
          :picker-date.sync="pickerDate"
          no-title
          @change="updateMonthYear"
          @update:picker-date="updatePickedYear"
          next-icon="mdi-menu-right"
          prev-icon="mdi-menu-left"
          :min="pickerMin" 
          :max="pickerMax"
        >
          <v-btn class="date-picker-close" text color="grey"  @click="closeDatePicker">{{ $t("btn_close_date_time_picker") }}</v-btn>
        </v-date-picker>
      </v-menu>
      <v-btn icon class="v-calendar-right-button ma-2" @click="changeMonth(2)">
        <img src="@/assets/btn_next.png" alt="required" width="20" />
      </v-btn>
    </div>
    <div>
      <button id="btnToday" @click="resetToday()">
       {{ $t("btn_today") }}
      </button>
    </div>
    <div style="padding: 5px;">
      <button type="button" id="btnShowList"  v-show="isMobile" @click="transitListvacation()"><img id="applyImage" width="25px" src="../../assets/showlist.png">
      </button>
    </div>
  </v-main>
</template>

 <script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { ListEvents, resizeMixin, setLanguage} from "@/utilities/CommonUtilities";
import timeOut from 'lodash';
import moment from 'moment';

export default {
  mixins: [resizeMixin],
  data: () => ({
    picker: null,
    pickerDate: null,
    arrayEvents: null,
    menu: false,
    listInprogressMonth: null,
    pickerMax: '2034-12-31',
    pickerMin: '2014-01-01',
    yearSelected: false,
  }),
  created() {
    //Format YYYY-MM
    if (
      this.filterDatePicker == null ||
      this.filterDatePicker.dateChoosed === undefined
    ) {
      this.picker = new Date().toISOString().substring(0, 7);
      this.saveDate(this.picker);
    } else {
      this.picker = this.filterDatePicker.dateChoosed.substring(0, 7);
    }
    //set language 
    setLanguage(this.currentLanguage);
  },
  inject: ["dataSource", "notifyBus"],
  computed: {
    ...mapState(["token","userInfo"]),
    ...mapState({
      currentLanguage: state => state.homeData.currentLanguage,
    }),
    ...mapGetters({
      filterDatePicker: "homeData/getFilterInfo",
    }),
    monthYear() {
      const options = { month: "short", year: "numeric" };
      const date = new Date(this.picker);
      return date.toLocaleDateString(this.$i18n.locale, options);
    },
    vuetifyLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    ...mapMutations({
      saveFilter: "homeData/saveFilter",
      setCurrentTab: "homeData/setCurrentTab",
      setSelectedTab: "homeData/setSelectedTab",
    }),
    closeDatePicker() {
      if (!this.yearSelected) {
      this.$refs.datePicker.activePicker = 'MONTH';
      }
      this.menu = false;
      this.yearSelected = false;
      },
    changeMonth(step) {
      const [year, month] = this.picker.split("-");
      const newMonth = new Date(year, month - 1 + step, 1);
      this.picker = newMonth.toISOString().substring(0, 7);
      this.calendarDate = newMonth.toISOString().substring(0, 10);
      this.saveDate(this.calendarDate);
      this.notifyBus.$emit("calendarDate", this.calendarDate);
      this.notifyBus.$emit(ListEvents.vacationList);
    },
    saveDate(paramDate, isShowDateChoose) {
      var filterInfoTemp = {};
      const [year, monthIndex] = paramDate.split("-").map(Number);
      let firstDay = new Date(year, monthIndex - 1, 1);
      let lastDay = new Date(year, monthIndex, 0);
      let currentDay = new Date();
      firstDay.setDate(firstDay.getDate() + 1);
      lastDay.setDate(lastDay.getDate() + 1);
      let currentDate = currentDay.toISOString().substring(0, 10);
      let firstDayOfMonth = firstDay.toISOString().substring(0, 10);
      let lastDayOfMonth = lastDay.toISOString().substring(0, 10);
      const currentMonthYear = new Date().toISOString().substring(0, 7);
      let yearMonthChoosed = paramDate.substring(0, 7);
      if(isShowDateChoose){
        filterInfoTemp.showDateChoose = true;
      } else {
        filterInfoTemp.showDateChoose = false;
      }
      
      filterInfoTemp.datePicker = paramDate;
      filterInfoTemp.dateChoosed = paramDate;
      filterInfoTemp.firstDayOfMonth = firstDayOfMonth;
      filterInfoTemp.lastDayOfMonth = lastDayOfMonth;
      if (
        this.filterDatePicker === null ||
        this.filterDatePicker.fromDate === undefined
      ) {
        filterInfoTemp.fromDate = currentDate;
        filterInfoTemp.toDate = lastDayOfMonth;
      } else {
        // check choose current date is month year then show from now to last day of month.
        if(currentMonthYear === yearMonthChoosed){
          filterInfoTemp.fromDate = currentDate;
        } else {
          filterInfoTemp.fromDate = firstDayOfMonth;
        }
        filterInfoTemp.toDate = lastDayOfMonth;
      }
      this.saveFilter(filterInfoTemp);
    },
    updateMonthYear(value) {
      this.picker = value;
      const [year, month] = value.split("-");
      this.calendarDate = new Date(year, month).toISOString().substring(0, 10);
      this.saveDate(this.calendarDate);
      this.notifyBus.$emit(ListEvents.calendarDate, this.calendarDate);
      this.notifyBus.$emit(ListEvents.vacationList);
    },
    eventColorFunction(event) {
      let colors = [];
      if (this.arrayEvents && this.arrayEvents.approved.includes(event)) {
      colors.push("v-date-picker-small-cricle-approved");
      }
      if (this.arrayEvents && this.arrayEvents.inprogress.includes(event)) {
      colors.push("v-date-picker-small-cricle-inprogress");
      }
      return colors;
      },
    async getStatusVacationMonth(year, userID) {
      this.notifyBus.$emit(ListEvents.showLoadingIndicator);
      try {
        let params 
        if(userID === undefined){
          params = { year: year, token: this.token };
        }else{
          params = { year: year, token: this.token,user_id: userID };
        }
        let responseListUser = await this.dataSource.getData(
          this.dataSource.statusVacationsURL,
          params
        );
        
        this.listInprogressMonth = responseListUser.data.inprogress["months"];
        this.listApprovedMonth = responseListUser.data.approved["months"];

        let monthsApproved = this.convertObjectToArray(this.listApprovedMonth, year);
        let monthsInprogress = this.convertObjectToArray(this.listInprogressMonth, year);
        
        this.$set(this, 'arrayEvents', {
          approved: monthsApproved,
          inprogress: monthsInprogress
          });

        this.showErrorView = false;
      } catch (ex) {
        this.showErrorView = true;
        return;
      } finally {
        this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
      }
    },
    convertObjectToArray(obj, year) {
      return Object.entries(obj)
        .filter(([, value]) => value === 1)
        .map(([month]) => `${year}-${month.padStart(2, "0")}`)
        .sort();
    },
    resetPicker(){
      if(!this.menu){
        this.updatePickedYear(this.picker);
      }
      this.pickerDate = this.filterDatePicker.dateChoosed.substring(0, 7);
    },
    resetToday(){
      this.picker = new Date().toISOString().substring(0, 7);
      this.calendarDate = moment().format("YYYY-MM-DD");
      this.saveDate(this.calendarDate, true);
      this.notifyBus.$emit("calendarDate", this.calendarDate);
      if(this.isMobile) {
          this.$router.push({
          name: "listVacation",
          params: { option: "list" },
        });
      } else {
        this.notifyBus.$emit(ListEvents.vacationList);
      }
    },
    transitListvacation() {
      var filterInfoTemp = {};
      let yearMonth = this.filterDatePicker.dateChoosed.substring(0, 7)
      const currentMonthYear = new Date().toISOString().substring(0, 7);
      filterInfoTemp.dateChoosed = yearMonth;
      if(currentMonthYear === yearMonth){
        filterInfoTemp.fromDate = new Date().toISOString().substring(0, 10);
      } else {
        filterInfoTemp.fromDate = this.filterDatePicker.firstDayOfMonth;
      }
      filterInfoTemp.toDate = this.filterDatePicker.lastDayOfMonth;
      filterInfoTemp.firstDayOfMonth = this.filterDatePicker.firstDayOfMonth;
      filterInfoTemp.lastDayOfMonth = this.filterDatePicker.lastDayOfMonth;
      this.saveFilter(filterInfoTemp);
      this.$router.push({
        name: "listVacation",
        params: { option: "list" },
      });
    },
    updatePickedYear: timeOut.debounce(function(value){
      let year =  value.split('-')[0]; 
        this.getStatusVacationMonth(year, this.userInfo.userID);
    }, 800)
  },
};
</script> 

<style scoped>
::v-deep .accent--text .v-btn__content{
  color: #1F97FE !important;
}
::v-deep .v-date-picker-small-cricle-inprogress {
  width: 10px;
  height: 10px;
  background-color: #febd1f;
  top: -39px;
  right: -4px;
  display: none;
  position: absolute;
}
::v-deep .v-date-picker-small-cricle-approved {
  width: 10px;
  height: 10px;
  background-color:#3fe090;
  top: -39px;
  right: 8px;
  position: absolute;
}

::v-deep .v-date-picker-table--month td {
  width: 75px !important;
  margin: 5px !important;
}

.v-date-picker-table__events {
  top: 0px;
}

::v-deep .v-date-picker-table--month td .v-btn {
  width: 75px;
  height: 52px;
}

::v-deep .v-card__actions {
  align-items: center;
  display: block;
  padding: 8px;
  text-align: center !important;
}

.v-card__actions > .v-btn.v-btn {
  font-size: 14px !important;
  font-weight: bold;
  border-radius: 18px !important;
  color: #ffffff !important;
  padding-left: 30px;
  padding-right: 30px;
  height: 35px;
  width: 128px;
  background-color: #c7c7c7;
  margin-bottom: 25px;
}

::v-deep .v-date-picker-header__value button {
  font-size: 40px;
}

.v-picker {
  width: 360px;
  height: 410px;
  border-radius: 31px;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default {
  padding: 0px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  border: 1px solid #c7c7c7;
  border-radius: 10px;
}

::v-deep .v-date-picker-header .v-btn--icon.v-size--default .v-icon {
  font-size: 80px;
  color: #1f97fe !important;
}

.v-calendar-left-button {
  background-image: url("../../assets/arrow_left.png");
  background-position: center;
  margin-right: 70px !important;
}

.v-calendar-right-button {
  background-image: url("../../assets/arrow_right.png");
  background-position: center;
  margin-left: 70px !important;
}

::v-deep .v-card__actions {
  align-items: center;
  display: block;
  padding: 8px;
  text-align: center !important;
}

.v-menu__content{
  width: 360px !important;
  height: 410px !important;
  margin-left: -123px !important;
  margin-top: -36px !important;
  border-radius: 31px;
}

::v-deep .v-main__wrap {
  /* text-align: start; */
  display: flex;
  align-items: center;
  margin: 5px 0 5px 0;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default{
  transition: border-color 0.6s ease-in-out !important;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default:hover{
  border: 2px solid #007bff !important;
  transition: border-color 0.5s ease-in-out !important;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default.date-picker-close:hover{
  border: none !important;
  opacity: 0.8;

}
::v-deep .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before{
  background-color: #badcfa !important;
}

::v-deep .v-date-picker-table--month td .v-btn:active,
::v-deep .v-date-picker-table--month td .v-btn:focus {
  background-color: white !important;
}

::v-deep .v-date-picker-table--month td .v-btn{
  background-color: white !important;
  border: 1px solid #c7c7c7 !important;
}
::v-deep .accent{
  color: #1f97fe !important;
}

::v-deep .v-btn:before {
  background-color: #a2d3fd ;
  color: #1f97fe !important;
}
::v-deep .accent {
  color: black !important;
}
::v-deep .v-date-picker-years.v-date-picker-years {
    padding: 0;
    margin-top: 30px;
}
#btnToday{
  width: 80px;
  height: 35px;
  border-radius: 24px;
  border: 1px solid #C7C7C7;
  opacity: 1;
  background-color: white;
  font-size: 1em;
  text-transform: capitalize;
  font-weight: normal !important;
  margin-right: 15px;
  box-shadow: none;
  }

#btnShowList{
  background-color: #007bff;
  width: 50px;
  height: 35px;
  border-radius: 24px;
  opacity: 1;
  border: transparent !important;
  padding: 6px 10px;
  margin-right: 15px;
}
#btnShowList:hover{
  opacity: 0.8;
}
#btnToday:focus-visible{
  outline: none;
}

@media (pointer: fine){
  #btnToday:hover{
  background: #F2F2F2 0% 0% no-repeat padding-box ;
  border: transparent ;
}
}
@media (max-width: 843px) {

  .v-calendar-right-button{
    margin-left: 35px !important;
  }
  .v-calendar-left-button {
    margin-right: 35px !important;
  }
}
@media (max-width: 360px) {
  .v-calendar-right-button{
    margin-left: 20px !important;
  }
  .v-calendar-left-button {
    margin-right: 20px !important;
  }
  .monthYear{
    font-size: 18px !important;
  }
  .v-application .ma-2{
    margin: 5px 20px 7px 5px !important;
  }
  .v-menu__content.theme--light.menuable__content__active {
    left: 0px !important;
    margin: 0 auto !important;
    text-align: center !important;
    right: 0 !important;
    top: 70px !important;
    max-width: 430px;
  }
  .v-btn__content img{
    width: 15px;
  }
}
@media (min-width: 361px) and  (max-width: 407px) {
  .v-calendar-right-button{
    margin-left: 25px !important;
  }
  .v-calendar-left-button {
    margin-right: 25px !important;
  }
  .v-application{
    margin: -8px !important;
  }
  .monthYear{
    font-size: 20px !important;
  }
  .v-menu__content.theme--light.menuable__content__active {
    left: 0px !important;
    margin: 0 auto !important;
    text-align: center !important;
    right: 0 !important;
    top: 70px !important;
    max-width: 450px;
    height: 410px !important;
  }
  .v-btn__content img{
    width: 15px;
  }
  
}
@media only screen and (min-width: 410px) and (max-width: 767px) {
  .v-menu__content.theme--light.menuable__content__active {
    left: 0px !important;
    margin: 0 auto !important;
    text-align: center !important;
    right: 0 !important;
    top: 70px !important;
    max-width: 450px;
    height: 435px !important;
  }

  .v-date-picker-header {
    padding: 10px 16px !important;
  }
  ::v-deep .v-date-picker-table--month td{
    padding: 5px !important;
  }
  .v-picker{
    height: 435px !important;
  }
  .v-calendar-left-button {
    margin-right: 45px !important;
  }
  .v-calendar-right-button {
    margin-left: 45px !important;
  }
  ::v-deep .v-main__wrap {
    justify-content: space-between;
  }
  .datePicker{
    margin-left: 5px;
  }
  ::v-deep .v-main__wrap {
    margin: 20px 0 10px 0;
  }
}

@media (pointer: coarse){
  ::v-deep .v-main__wrap {
    justify-content: space-between;
  }
  .datePicker{
    margin-left: 5px;
  }
  #btnToday:active{
  background: #F2F2F2 0% 0% no-repeat padding-box ;
  border: transparent ;
  }
}
</style>